const files = require.context('./modules', false, /\.js$/)
const res = {}

files.keys().forEach((key) => {
  res[key.match(/\/([\w\W]+)\.js/)[1]] = files(key).default
})

export default res